import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';

import Store from './store/redux';

import Router from './router';
import * as serviceWorker from './serviceWorker';

import componentConstruct from "./apis";

const env = process.env;
const service = new componentConstruct({ env });

window.$Store = Store;
window.$axios = service;

ReactDOM.render(
  <React.Profiler id="reactRouter" onRender={() => {}}>
    <Router />
  </React.Profiler>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
